import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/predplatne" as const,
	[Locale.en]: "/subscriptions" as const,
} satisfies LocalizedString;

export function getSubscriptionListingPath(tenant: Tenant, b2cDetailId?: string): string {
	const basePath = getPathInLocale(tenant.locale, pathMap);
	return b2cDetailId ? `${basePath}#${b2cDetailId}` : basePath;
}
